import { RouteRecordRaw } from "vue-router";
import { t } from "@/core/i18n";

export const routes: RouteRecordRaw = {
  path: "/vouchers-v2",
  name: "vouchers-v2",
  redirect: { name: "DistributorManagement" },
  children: [
    {
      path: "/vouchers-v2/distributors",
      name: "DistributorManagement",
      component: () => import("@/modules/Vouchers-v2/screens/Distributors.vue"),
      meta: {
        breadcrumb: [
          { title: t("vouchers"), routeName: "vouchers-v2" },
          { title: t("distributors"), routeName: "DistributorManagement" },
        ],
      },
    },
    {
      path: "distributors/create",
      name: "CreateDistributor",
      component: () =>
        import("@/modules/Vouchers-v2/screens/DistributorForm.vue"),
      meta: {
        breadcrumb: [
          { title: t("vouchers"), routeName: "vouchers-v2" },
          { title: t("distributors"), routeName: "DistributorManagement" },
          { title: t("create-distributor"), routeName: "CreateDistributor" },
        ],
      },
    },
    {
      path: "distributors/:id",
      name: "UpdateDistributor",
      component: () =>
        import("@/modules/Vouchers-v2/screens/DistributorForm.vue"),
      meta: {
        breadcrumb: [
          { title: t("vouchers"), routeName: "vouchers-v2" },
          { title: t("distributors"), routeName: "DistributorManagement" },
          { title: t("update-distributor"), routeName: "UpdateDistributor" },
        ],
      },
    },
    {
      path: "/vouchers-v2/batches",
      name: "VoucherBatchManagement",
      component: () =>
        import("@/modules/Vouchers-v2/screens/VoucherBatches.vue"),
      meta: {
        breadcrumb: [
          { title: t("vouchers"), routeName: "vouchers-v2" },
          { title: t("batches"), routeName: "VoucherBatchManagement" },
        ],
      },
    },
    {
      path: "/vouchers-v2/vouchers",
      name: "VoucherManagement",
      component: () => import("@/modules/Vouchers-v2/screens/VouchersList.vue"),
      meta: {
        breadcrumb: [
          { title: t("vouchers"), routeName: "vouchers-v2" },
          { title: t("vouchers"), routeName: "vouchers" },
        ],
      },
    },
    {
      path: "/vouchers-v2/unique-vouchers",
      name: "UniqueVouchers",
      component: () =>
        import("@/modules/Vouchers-v2/screens/UniqueVouchers.vue"),
      meta: {
        breadcrumb: [
          { title: t("vouchers"), routeName: "vouchers-v2" },
          { title: t("unique-vouchers"), routeName: "UniqueVouchers" },
        ],
      },
    },
    {
      path: "/vouchers-v2/unique-voucher-uses/:id",
      name: "unique-voucher-uses",
      component: () =>
        import("@/modules/Vouchers-v2/screens/UniqueVouchersUses.vue"),
      meta: {
        breadcrumb: [
          { title: t("vouchers"), routeName: "vouchers-v2" },
          { title: t("unique-vouchers"), routeName: "UniqueVouchers" },
          { title: t("unique-voucher-uses"), routeName: "unique-voucher-uses" },
        ],
      },
    },
    {
      path: "/vouchers-v2/create-unique-voucher",
      name: "create-unique-voucher",
      component: () =>
        import("@/modules/Vouchers-v2/screens/CreateUniqueVoucher.vue"),
      meta: {
        breadcrumb: [
          { title: t("vouchers"), routeName: "vouchers-v2" },
          { title: t("unique-vouchers"), routeName: "UniqueVouchers" },
          {
            title: t("create-unique-voucher"),
            routeName: "create-unique-voucher",
          },
        ],
      },
    },
    {
      path: "batches/create",
      name: "CreateVoucherBatch",
      component: () =>
        import("@/modules/Vouchers-v2/screens/VoucherBatchForm.vue"),
      meta: {
        breadcrumb: [
          { title: t("vouchers"), routeName: "vouchers-v2" },
          { title: t("batches"), routeName: "VoucherBatchManagement" },
          { title: t("create-batch"), routeName: "CreateVoucherBatch" },
        ],
      },
    },
    {
      path: "batches/:id",
      name: "UpdateVoucherBatch",
      component: () =>
        import("@/modules/Vouchers-v2/screens/VoucherBatchForm.vue"),
      meta: {
        breadcrumb: [
          { title: t("vouchers"), routeName: "vouchers-v2" },
          { title: t("batches"), routeName: "VoucherBatchManagement" },
          { title: t("update-batch"), routeName: "UpdateVoucherBatch" },
        ],
      },
    },
    {
      path: "/vouchers-v2/subBatches/:batchId",
      name: "SubBatchManagement",
      component: () => import("@/modules/Vouchers-v2/screens/SubBatches.vue"),
      meta: {
        breadcrumb: [
          { title: t("vouchers"), routeName: "vouchers-v2" },
          { title: t("batches"), routeName: "VoucherBatchManagement" },
          { title: t("sub-batches"), routeName: "SubBatchManagement" },
        ],
      },
    },
    {
      path: "subBatches/:batchId/create",
      name: "CreateSubBatch",
      component: () => import("@/modules/Vouchers-v2/screens/SubBatchForm.vue"),
      meta: {
        breadcrumb: [
          { title: t("vouchers"), routeName: "vouchers-v2" },
          { title: t("batches"), routeName: "VoucherBatchManagement" },
          { title: t("sub-batches"), routeName: "SubBatchManagement" },
          { title: t("create-sub-batch"), routeName: "CreateSubBatch" },
        ],
      },
    },
    {
      path: "/vouchers-v2/exports",
      name: "VoucherExports",
      component: () =>
        import("@/modules/Vouchers-v2/screens/VoucherExports.vue"),
      meta: {
        breadcrumb: [
          { title: t("batches"), routeName: "VoucherBatchManagement" },
          { title: t("exports"), routeName: "VoucherExports" },
        ],
      },
    },
  ],
};
